import React, { useContext } from 'react'
import { CARD_BODY_COLUMN_DESCRIPTION } from '../../helpers/card-body-column-description'
import { ClientContext } from '../../context/client-context'

export const Disclaimer = ({ initialMessage = 'Al crear una cuenta' }) => {
  const { tenant } = useContext(ClientContext)
  return (
    <div className={`${CARD_BODY_COLUMN_DESCRIPTION} mt-3`}>
      <p className="disclaimer small-print">
        {initialMessage}, aceptas el
        <a href={tenant.privacyUrl} target='_blank' rel="noreferrer" style={{ textDecoration: 'none' }}><strong className="disclaimer-underline"> Aviso de Privacidad </strong></a>
        y los
        <a href={tenant.termsUrl} target='_blank' rel="noreferrer" style={{ textDecoration: 'none' }}><strong className="disclaimer-underline"> Términos y Condiciones</strong></a>
        , así como el envío de noticias y promociones exclusivas de {tenant.promoName}.
      </p>
    </div>
  )
}
